// extracted by mini-css-extract-plugin
module.exports = {"rating-submitted":"RatingSubmitted_rating-submitted__qO83W"};